// v1
/**
 * The racket sports' stat type names, old and new.
 *
 * Badminton's `StatType` rows were renamed to line up with tennis: `Point Won`
 * → `Points Won`, `Service` → `Serve`, `Point Played` → `Points Played`,
 * `Service Won` → `Serve Won`, and `Double Fault` → `Service Fault` (badminton
 * has one serve and cannot double fault).
 *
 * **Both spellings are listed on purpose.** The `Stat` rows themselves followed
 * the rename automatically, because they join on id — but this bundle and the
 * database change ship separately, and whichever lands second would otherwise
 * take every badminton screen to zero in between. Silent zeroes, not errors:
 * the screens would render, they would just be wrong.
 *
 * Mirrors `backend/src/utils/racketStatNames.js`. Both can drop the old names
 * once the rename is applied everywhere.
 */

export const POINTS_WON_NAMES = ["Points Won", "Point Won"];
export const POINTS_PLAYED_NAMES = ["Points Played", "Point Played"];
export const SERVE_NAMES = ["Serve", "Service"];
export const SERVE_WON_NAMES = ["Serve Won", "Service Won"];
export const SERVE_FAULT_NAMES = ["Double Fault", "Service Fault"];

/** does this stat type name mean the given concept, under either spelling? */
export const isName = (names, name) => names.includes(name);

/** the server's row for a concept, whichever spelling it currently carries */
export const findStatType = (statTypes, names) =>
  (statTypes || []).find((st) => names.includes(st.name));

/**
 * Read a total out of a `{ [statTypeName]: value }` map under either spelling.
 *
 * The cached profile and organisation stats are keyed by **name**, so a rename
 * leaves a cache holding the old key while the code asks for the new one. The
 * cache does not self-invalidate on a rename either — it compares against the
 * newest `Stat.createdAt`, and a rename touches no stat — so without this a
 * profile would show 0 until something else forced a rebuild.
 */
export const readTotal = (data, names) => {
  for (const n of names) {
    const v = data?.[n];
    if (v !== undefined && v !== null) return v;
  }
  return undefined;
};
